'use client';
import React from 'react';
import Image from 'next/image';

interface RecipeSectionMobileProps {
  className?: string;
  backgroundImage?: string;
  overlayImage?: string;
  height?: string;
}

const RecipeSectionMobile: React.FC<RecipeSectionMobileProps> = ({ 
  className = '',
  backgroundImage = '/images/img_shutterstock2502968219_1.png',
  overlayImage = '/images/img_receta_1.png',
  height = 'h-[200px]'
}) => {
  return null;
};

export default RecipeSectionMobile; 